const Marquee = ({ items }) => {
  return (
    <div
      data-testid="editorial-marquee"
      className="marquee-wrap relative overflow-hidden border-y border-[#FFE600]/25 bg-[#0D0F13] py-5"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
            {items.map((item, idx) => (
              <span
                key={idx}
                className="flex items-center font-display text-2xl sm:text-3xl font-semibold uppercase tracking-wide text-[#F3F4F6]/85"
              >
                <span className="px-7">{item}</span>
                <span className="text-[#FFE600] text-xl">///</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
